import Swiper from "swiper";
import { findControls } from "@plugins";

function initResentlyViewedSlider() {
    const resentlyViewedSlider = document.querySelector(".js-resently-viewed-slider-init");

    if (resentlyViewedSlider) {
        const sliderContainer = resentlyViewedSlider.querySelector(".js-resently-viewed-container");
        const controls = findControls(resentlyViewedSlider, ".js-resently-viewed-controls");

        new Swiper(sliderContainer, {
            speed: 400,
            spaceBetween: 0,
            navigation: {
                prevEl: controls.buttonPrev,
                nextEl: controls.buttonNext,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                    spaceBetween: 16,
                },
                375: {
                    slidesPerView: 1.6,
                    spaceBetween: 16,
                },
                420: {
                    slidesPerView: 1.8,
                    spaceBetween: 16,
                },
                500: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                },
                600: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 6,
                    shortSwipes: false,
                },
            },
        });
    }
}

initResentlyViewedSlider();
